import { useMemo } from "react";
import { useHomePage } from "../../context/HomePageContext";
import { useLanguage } from "../../context/LanguageContext";
import { useCmsLink } from "../../hooks/useCmsLink";
import { resolveHero } from "../../lib/homePageContent";
import "../../style/animations.css";

export default function HeroHome() {
  const { data } = useHomePage();
  const { language } = useLanguage();
  const goTo = useCmsLink();
  const hero = useMemo(() => resolveHero(data?.hero, language), [data, language]);

  return (
    <section
      className="
        w-full

        relative
        z-10
      ">
      <div
        className="
          relative
          isolate

          w-full

          h-[70vh]

          min-h-[500px]
          max-h-[750px]

          lg:h-[694px]

          overflow-hidden

          rounded-none
          lg:rounded-b-[120px]

          bg-[#63BEC2]
          translate-z-0
          will-change-transform
           [-webkit-mask-image:-webkit-radial-gradient(white,black)]
    [backface-visibility:hidden]
        ">
        {/* DESKTOP IMAGE */}
        <img
          src={hero.desktopImage}
          alt="gear"
          className="
            absolute

          
            right-0

        h-[100%]
        w-[100%]

            object-cover

            rounded-br-[150px]

            z-10

            transform-gpu
            will-change-transform

            pointer-events-none

            hidden
            lg:block

            animate-scale-in
          "
        />

        {/* MOBILE IMAGE */}
        <img
          src={hero.mobileImage}
          alt="gear"
          className="
          absolute
          inset-0

          rounded-b-[50px]

          w-full
          h-full

          object-cover
          object-[50%_5%]

          lg:hidden

          animate-scale-in
        "
        />
        {/* DARK GRADIENT */}
        <div
          className="
            absolute
            inset-0

            bg-[linear-gradient(180deg,rgba(31,58,75,0.55)_0%,rgba(99,190,194,0.15)_100%)]

            lg:bg-[linear-gradient(90deg,rgba(44,72,88,0.88)_0%,rgba(44,72,88,0.45)_28%,rgba(44,72,88,0)_58%)]

            z-20
          "
        />

        {/* MOBILE OVERLAY */}
        <div
          className="
            absolute
            inset-0

     

            lg:hidden

            z-20
          "
        />

        {/* HERO CONTENT */}
        <div
          className="
          relative
          z-20

          flex
          flex-col
          justify-center

          h-full

          px-6
          pt-24

          lg:px-[88px]
        ">
          {/* TITLE */}
          <h1
            style={{ animationDelay: "0.15s" }}
            className="
            whitespace-pre-line
            max-w-[280px]

            text-[38px]
            leading-[46px]

            font-bold
            text-white

            sm:max-w-[340px]
            sm:text-[46px]
            sm:leading-[54px]

            lg:max-w-[520px]
            lg:text-[56px]
            lg:leading-[66px]

            animate-fade-in-up
          ">
            {hero.title}
          </h1>

          {/* BUTTON */}
          <button
            onClick={() => goTo(hero.buttonLink)}
            style={{ animationDelay: "0.45s" }}
            className="
            mt-8

            w-[180px]
            h-[60px]

            rounded-full

            border
            border-white/50

            bg-white/10
            backdrop-blur-md

            text-white
            text-[18px]
            font-semibold

            transition-all
            duration-300

            hover:bg-white/20
            hover:scale-[1.04]
            active:scale-95

            animate-fade-in-up
          ">
            {hero.buttonLabel}
          </button>
        </div>
      </div>
    </section>
  );
}
